<ng-container *ngIf="overlay; else inlineSpinner">
  <div class="overlay">
    <div class="center">
      <div class="loader-card">
        <div class="corporate-spinner"></div>
        <div class="loading-text">Loading...</div>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #inlineSpinner>
  <div class="loader-container inline">
    <div class="corporate-spinner scaled"></div>
  </div>
</ng-template>

